import { render, staticRenderFns } from "./goods_grid_tab.vue?vue&type=template&id=71d77e4b&scoped=true"
import script from "./goods_grid_tab.vue?vue&type=script&lang=js"
export * from "./goods_grid_tab.vue?vue&type=script&lang=js"
import style0 from "./goods_grid_tab.vue?vue&type=style&index=0&id=71d77e4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d77e4b",
  null
  
)

export default component.exports